import { useRef, useState, useEffect } from "react";

export const useDropdownPosition = (isOpen: boolean) => {
  const [isPositionedTop, setIsPositionedTop] = useState(false);
  const triggerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && triggerRef.current && dropdownRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const availableSpaceBelow = window.innerHeight - triggerRect.bottom;
      const availableSpaceAbove = triggerRect.top;

      if (
        availableSpaceBelow < dropdownRect.height &&
        availableSpaceAbove > dropdownRect.height
      ) {
        setIsPositionedTop(true);
      } else {
        setIsPositionedTop(false);
      }
    }
  }, [isOpen]);

  return {
    isPositionedTop,
    triggerRef,
    dropdownRef
  };
};
